export enum AdequacySubmoduleEnum {
  TrendChart = "trendChart",
  ViewMap = "viewMap",
  GapManagement = "gapManagement",
}
